'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _DeleteUserModal = _interopRequireDefault(require("Modals/DeleteUserModal"));
var _EnhancedTableHead = _interopRequireDefault(require("Components/Lists/EnhancedTableHead"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _Link = _interopRequireDefault(require("Pure/Link"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
_moment.default.locale('fr');
let app = window.app;
class Users extends _react.Component {
  state = {
    selected: [],
    users: [],
    users_count: 0,
    page: 0,
    rows_per_page: 25,
    order: 'desc',
    order_by: 'created_at',
    openDeleteUserModal: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchUsers({});
    component.fetchSectors();
  }
  fetchUsers = ({
    page,
    order,
    order_by
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    page = typeof page === 'undefined' ? state.page : page;
    order = order || state.order;
    order_by = order_by || state.order_by;
    component.setState({
      loading: true
    });
    qwest.post('/user/get-all', {
      limit: state.rows_per_page,
      skip: state.rows_per_page * page,
      with_count: true,
      order: order,
      order_by: order_by
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        users: response.users,
        users_count: response.count
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchSectors = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/sector/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        sectors: response.sectors
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  openDeleteUserModal = ({
    user_id,
    e
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openDeleteUserModal: true,
      delete_modal_user: user_id,
      delete_modal_trigger: e.target
    });
  };
  closeDeleteUserModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openDeleteUserModal: false,
      delete_modal_user: undefined,
      delete_modal_trigger: undefined
    });
    component.fetchUsers({});
  };
  getSectorName = sector_id => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!state.sectors) return;
    let sector = (state.sectors || []).find(function (sector) {
      return sector.id === sector_id;
    });
    return sector?.name;
  };
  handleChangePage = (e, page) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      page: page
    });
    component.fetchUsers({
      page: page
    });
  };
  getRoleLabel = role => {
    const component = this,
      props = this.props,
      state = this.state;
    let label;
    switch (role) {
      case "accompanist":
        label = "Accompagnateur";
        break;
      case "admin":
        label = "Administrateur";
        break;
      case "agent":
        label = "Responsable de secteur";
        break;
      default:
        break;
    }
    return label;
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const empty_rows = state.rows_per_page - Math.min(state.rows, state.users_count - state.page * state.rows_per_page);
    _moment.default.locale('fr');
    const rows = state.users.filter(user => user.roles.includes('super_admin') === false).map(function (data) {
      const link = /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: '/configuration/liste-des-utilisateurs/' + data.id,
        className: "u-link-only"
      });
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        tabIndex: -1,
        key: data.id
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.lastname, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.firstname, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.login, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.phone_number !== "" ? data.phone_number : data.home_phone_number, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, component.getSectorName(data.sector), link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, component.getRoleLabel(data.roles[0]), link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "text",
        color: "secondary",
        onClick: e => component.openDeleteUserModal({
          user_id: data.id,
          e: e
        })
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
        color: "secondary"
      }))));
      return output;
    });
    const columns = [{
      id: 'lastname',
      sortable: false,
      numeric: false,
      label: 'Nom',
      center: true
    }, {
      id: 'firstname',
      sortable: false,
      numeric: false,
      label: 'Prénom',
      center: true
    }, {
      id: 'login',
      sortable: false,
      numeric: false,
      label: 'E-mail',
      center: true
    }, {
      id: 'phone_number',
      sortable: false,
      numeric: false,
      label: 'Numéro de téléphone',
      center: true
    }, {
      id: 'sector',
      sortable: false,
      numeric: false,
      label: 'Secteur',
      center: true
    }, {
      id: 'roles',
      sortable: false,
      numeric: false,
      label: 'Rôle',
      center: true
    }, {
      id: 'actions',
      sortable: false,
      numeric: false,
      label: '',
      center: true
    }];
    let output = /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "dashboard-table",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-labelledby": "Utilisateurs"
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      onRequestSort: component.handleRequestSort,
      order: state.order,
      order_by: state.order_by,
      row_count: rows.length,
      columns: columns
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, rows, empty_rows > 0 ? /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      style: {
        height: 49 * empty_rows
      }
    }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      colSpan: 4
    })) : undefined)), /*#__PURE__*/_react.default.createElement(_TablePagination.default, {
      onChangePage: component.handleChangePage,
      component: "div",
      count: state.users_count,
      rowsPerPage: state.rows_per_page,
      rowsPerPageOptions: [],
      page: state.page,
      backIconButtonProps: {
        'aria-label': 'Page précédente'
      },
      nextIconButtonProps: {
        'aria-label': 'Page suivante'
      },
      labelDisplayedRows: ({
        from,
        to,
        count
      }) => from + '-' + to + ' sur ' + count
    }), /*#__PURE__*/_react.default.createElement(_DeleteUserModal.default, {
      user_to_delete: state.delete_modal_user,
      open: state.openDeleteUserModal,
      onClose: component.closeDeleteUserModal,
      delete_modal_trigger: state.delete_modal_trigger
    }));
    return output;
  }
}
exports.default = Users;
